const average = (arr) =>
  arr.reduce((acc, cur, i, arr) => acc + cur / arr.length, 0);

export default function WatchedMovies({ watchedMovie,onDeleteWatchedMovie }) {
  return (
    <>
      <StatisticsOfWatchedMoves watchedMovie={watchedMovie} />
      <ul className="px-5">
        {watchedMovie.map((movie) => {
          return <Movie movie={movie} key={movie.imdbID} onDeleteWatchedMovie={onDeleteWatchedMovie} />;
        })}
      </ul>
    </>
  );
}
function Movie({ movie, onDeleteWatchedMovie }) {

  
  return (
    <li className="flex items-center justify-between mt-4 gap-2 w-full">
      <div className="flex items-start mt-4 gap-2 w-[70%]">
      <img
        src={movie.poster}
        alt={movie.title}
        className="w-14 h-18 object-cover"
        />
      <div className="space-y-3 w-1/2">
        <h3 className="text-sm">{movie.title}</h3>
        <p className="flex justify-between text-sm mt-2 w-full">
          <span>⭐ {movie.imdbRating}</span>   <span>🌟 {movie?.userRating}</span>{" "}
          <span>🕛 {movie.runtime} min</span>
        </p>
      </div>
      </div>
    <button onClick={()=>onDeleteWatchedMovie(movie.imdbID)}>❌</button>
    </li>
  );
}

function StatisticsOfWatchedMoves({ watchedMovie }) {
  const runTimeAvg = average(
    watchedMovie.map((movie) => movie.runtime)
  ).toFixed(1);
  const imdbRatingAvg = average(
    watchedMovie.map((movie) => movie.imdbRating)
  ).toFixed(1);
  const userRatingAvg = average(
    watchedMovie.map((movie) => movie.userRating)
  ).toFixed(1);

  return (
    <div className="bg-background100 text-white w-full rounded-md p-2 mx-auto mb-5 ">
      <p className="text-2xl  uppercase font-mono">Movies you watched</p>
      <p className="flex justify-between text-sm mt-2">
        <span>#️⃣ {watchedMovie.length} movies</span>{" "}
        <span>⭐ {imdbRatingAvg}</span> <span>🌟 {userRatingAvg}</span>{" "}
        <span>🕛 {runTimeAvg} min</span>
      </p>
    </div>
  );
}
